module.exports = __webpack_public_path__ + "img/inhumans.11dd7edd.svg";